import React, { ReactElement, useState } from "react";

export interface EllipsisTextProps {
    text: string;
    charLimit: number;
}

const EllipsisText: React.FC<EllipsisTextProps> = ({ text, charLimit }): ReactElement => {
    const [userNameExpanded, setUserNameExpanded] = useState<boolean>(false);

    const toggleUsernameExpansion = () => {
        setUserNameExpanded(true);
        setTimeout(() => {
            setUserNameExpanded(false);
        }, 1500);
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
        if (e.key === "Enter" || e.key === " ") {
            toggleUsernameExpansion();
            e.preventDefault();
        }
    };

    const dispalyEllipsis = () => (
        // eslint-disable-next-line
        text?.length > charLimit && !userNameExpanded ? <span>...</span> : ""
    );

    const displayText = () => (
        // eslint-disable-next-line
        text?.length > charLimit && !userNameExpanded ? text.slice(0, (charLimit)) : text
    );

    return (
        <span
            role="button"
            tabIndex={0}
            onClick={toggleUsernameExpansion}
            onKeyDown={onKeyDown}
            aria-label="click to expand"
        >
            {displayText()}
            {dispalyEllipsis()}
        </span>
    );
};

export default EllipsisText;
